import React, { useEffect, useState } from "react";
import { isImage } from "../../../../helpers/image";
import { FileProperties } from "../../../../types/file.type";
import { Image } from "antd";

export default function ImageItem({ value }: { value: any }) {
	const [previewImage, setPreviewImage] = useState<string>();

	useEffect(() => {
		console.info("value change, will set preview");

		if (!value) {
			console.info("no value");
			setPreviewImage(undefined);
			return;
		}

		if (value instanceof File) {
			console.info("value instanceof File");
			if (isImage(value)) {
				console.info("type image");
				const reader = new FileReader();
				reader.onloadend = () => {
					console.info("onloadend, will set");
					setPreviewImage(reader.result as string);
				};
				reader.readAsDataURL(value);
			} else {
				console.info("not image, no preview");
				setPreviewImage(undefined);
			}
		} else {
			console.info("NOT - value instanceof File");
			const valueFileUrl = value as FileProperties;

			if (isImage(valueFileUrl as any)) {
				console.info("type image", valueFileUrl.fileUrl);
				setPreviewImage(valueFileUrl.fileUrl);
			} else {
				console.info("not image");
				setPreviewImage(undefined);
			}
		}
	}, [value]);

	return (
		<Image
			width={190}
			height={170}
			src={previewImage || "/images/no-preview.jpg"}
			style={{
				borderRadius: 8,
				objectFit: "cover",
			}}
		/>
	);
}
